<template>
  <div class="background-03">

    <v-layout row wrap>
      <v-flex xs12 sm2 md2 class="hidden-xs-only ">
        <image-app class="animated fadeInLeft" :imaSize="300" imaSrc="design/banco1-1-3" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm9 class="animated fadeInUp dura_1">
        <ui-title-one titleAccess="Sugerencias para ajustar el presupuesto  " titleLevel="h1">
          <template slot="partOne"> Sugerencias para <br></template>
          <template slot="partTwo">ajustar el </template>
          <template slot="partThree"> presupuesto </template>
        </ui-title-one>
      </v-flex>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc  :vidTittle="'Sugerencias para ajustar el presupuesto'" videoEmbed="ADMINISTRACIONDINERO40SugerenciasAjustarPresupuesto.mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12>
        <p>Haga clic sobre cada número para conocer las sugerencias.</p>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <bots-numbers-vert :numeroBotones="4">
        <div class="animated fadeInRight" slot="cont0">
          <p>
            Saque las  proporciones de gastos frente a sus ingresos, esto le ayudará a determinar qué porcentaje
            de su ingreso se está gastando en un uso específico, o si un gasto es demasiado elevado o no.
          </p>
          <image-app class="animated fadeInUp" :imaSize="450" imaSrc="contenido/gastos" imaAlt="Lo que usted gastó se divide en sus ingresos totales y obtiene la proporción de gastos"></image-app>
        </div>
        <div class="animated fadeInRight" slot="cont1">
          <p>
            No abandone la realización de su presupuesto. Recuerde revisarlo permanentemente.
            Sus hábitos de gasto pueden cambiar con el tiempo, por lo tanto controlar sus finanzas
            requerirá de un esfuerzo continuo.
          </p>
        </div>
        <div class="animated fadeInRight" slot="cont2">
          <p>
            Haga su presupuesto sencillo y realista.
          </p>
        </div>
        <div class="animated fadeInRight" slot="cont3">
          <p>
            Recuerde que en <strong>Mi perfil</strong> encontrará la herramienta calculadora de presupuesto, 
            la cual le facilitará revisar y actualizar su presupuesto de forma constante.
          </p>
        </div>
      </bots-numbers-vert>
    </v-layout>

  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", false);
  }
};
</script>



// WEBPACK FOOTER //
// davivienda-40.vue?0bb6c0ae